import { render, staticRenderFns } from "./EventDay.vue?vue&type=template&id=07357594&scoped=true"
import script from "./EventDay.vue?vue&type=script&lang=js"
export * from "./EventDay.vue?vue&type=script&lang=js"
import style0 from "./EventDay.vue?vue&type=style&index=0&id=07357594&lang=scss&scoped=true"
import style1 from "./EventDay.vue?vue&type=style&index=1&id=07357594&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07357594",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07357594')) {
      api.createRecord('07357594', component.options)
    } else {
      api.reload('07357594', component.options)
    }
    module.hot.accept("./EventDay.vue?vue&type=template&id=07357594&scoped=true", function () {
      api.rerender('07357594', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/EventDay.vue"
export default component.exports